import { ModalHandler } from "@lib/ModalHandler";
import { randNum } from "@lib/util/common";
import { Accessor } from "solid-js";
import {
  clickSaveButton,
  getQuestionHandler,
  waitForRegularSectionPage,
  waitForSOMainMenu,
} from "../form_handlers";
import { clickSurveySection } from "../form_util";

export async function completeGmPresets(_totalInStock: number, modalHandler: Accessor<ModalHandler>) {
  await fillUnitsAndCasesOverall(modalHandler);
  await fillShelfMaintenance(modalHandler);
  await fillDisplayMaintenance(modalHandler);
}

async function fillUnitsAndCasesOverall(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /units and cases overall/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("textinput", 1, /how many total units.*part of your distribution check/i)?.answer("0");
  getQuestionHandler("textinput", 2, /how many cases did you order overall/i)?.answer(
    randNum(0, 1).toString()
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillShelfMaintenance(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /shelf maintenance/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("textinput", 1, /unit.*added.*outside of the distribution check/i)?.answer(
    randNum(12, 18).toString()
  );
  getQuestionHandler("textinput", 2, /tag.*added.*outside.*dist.*check/i)?.answer(randNum(0, 1).toString());
  getQuestionHandler("radio", 3, /how many new items cut.*in/i)?.answer("0");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillDisplayMaintenance(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /display maintenance/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, /does the store have any existing display present/i)?.answer("NO");
  getQuestionHandler("radio", 3, /build.*new.*display.*or impact.*existing.*displays/i)?.answer("NO");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}
